export default __webpack_public_path__ + "static/media/medisouq-logo.2cf8b4a7.svg";